/**
 * DPW route constants (docs/dpw/02 §2).
 *
 * Deliberately a pure-constant module with zero imports: DPW components import routes from here so
 * they never pull the app-wide route registry (routes.ts → sitRoutes → stores → env.ts), which keeps
 * them unit-testable and store-free. `src/routing/catRoutes.ts` spreads this object into the app
 * route table, so the router and the components always agree.
 */
export const DPW_ROUTES = {
    dpw_briefing: '/dpw/briefing',
    dpw_initiatives: '/dpw/initiatives',
    dpw_categories: '/dpw/categories',
    dpw_category_fm: '/dpw/categories/facility-management',
    dpw_foundation: '/dpw/categories/facility-management/foundation',
    dpw_foundation_classification: '/dpw/categories/facility-management/foundation/classification',
    dpw_foundation_governance: '/dpw/categories/facility-management/foundation/governance',
    dpw_strategy: '/dpw/strategy/facility-management',
    dpw_strategy_intake: '/dpw/strategy/facility-management/intake',
    dpw_strategy_feedback: '/dpw/strategy/facility-management/feedback',
    dpw_strategy_approval: '/dpw/strategy/facility-management/approval',
    dpw_levers: '/dpw/levers',
    dpw_lever_spend_under_contract: '/dpw/levers/spend-under-contract',
    dpw_opportunity: '/dpw/opportunity/facilicore',
    dpw_initiative_create: '/dpw/initiatives/facilicore/create',
    dpw_initiative: '/dpw/initiatives/facilicore',
    dpw_finance_review: '/dpw/value/finance-review',
    dpw_end: '/dpw/end',
    dpw_value: '/dpw/value',
    dpw_recommendation: '/dpw/recommendation/facilicore-renewal',
} as const;

/** Longest-prefix-first breadcrumb table shared by the shell and the Atlas companion context label. */
export const DPW_BREADCRUMBS: readonly [prefix: string, title: string][] = [
    [DPW_ROUTES.dpw_foundation_classification, 'Categories › Facility Management › Foundation › Classification review'],
    [DPW_ROUTES.dpw_foundation_governance, 'Categories › Facility Management › Foundation › Supplier panel & contract links'],
    [DPW_ROUTES.dpw_foundation, 'Categories › Facility Management › Foundation worklist'],
    [DPW_ROUTES.dpw_category_fm, 'Categories › Facility Management'],
    ['/dpw/recommendation', 'Daily Briefing › Recommendation'],
    [DPW_ROUTES.dpw_strategy_intake, 'Strategy › Validate with stakeholders'],
    [DPW_ROUTES.dpw_strategy_feedback, 'Strategy › Feedback & conflicts'],
    [DPW_ROUTES.dpw_strategy_approval, 'Strategy › Approval'],
    ['/dpw/strategy', 'Strategy › Facility Management'],
    [DPW_ROUTES.dpw_lever_spend_under_contract, 'Strategy levers › Spend under contract'],
    [DPW_ROUTES.dpw_levers, 'Strategy levers'],
    [DPW_ROUTES.dpw_opportunity, 'Opportunity › FaciliCore Group'],
    [DPW_ROUTES.dpw_initiative_create, 'Initiatives › Create'],
    [DPW_ROUTES.dpw_initiative, 'Initiatives › FaciliCore European IFM MSA'],
    [DPW_ROUTES.dpw_finance_review, 'Value › Finance review'],
    [DPW_ROUTES.dpw_end, 'Every category has a next move'],
    [DPW_ROUTES.dpw_briefing, 'Daily Briefing'],
    [DPW_ROUTES.dpw_initiatives, 'Initiatives'],
    [DPW_ROUTES.dpw_categories, 'Categories'],
    [DPW_ROUTES.dpw_value, 'Value'],
];

export function dpwBreadcrumb(pathname: string): string {
    return DPW_BREADCRUMBS.find(([prefix]) => pathname.startsWith(prefix))?.[1] ?? 'Daily Briefing';
}
